import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

export interface ButtonsModalTable {
  label: string;
  class?: string;
  value: string;
}

@Component({
  selector: 'iw-modal-table',
  templateUrl: './modal-table.component.html',
  styleUrls: ['./modal-table.component.scss']
})
export class ModalTableComponent implements OnInit {

  // Pregunta
  @Input() question: string;
  // Arreglo de los botones
  @Input() buttonsAction: Array<ButtonsModalTable>;
  // Respuesta seleccionada de la pregunta
  @Output() evtResponse: EventEmitter<boolean> = new EventEmitter();
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Referencia al template de la modal
  @ViewChild('template') private template: TemplateRef<any>;

  constructor(private modalService: BsModalService) { }

  ngOnInit() {
  }
  /**
   * Funcion que realiza la apertura o renderizacion del modal en la vista
   *
   * @memberof ModalTableComponent
   */
  openModal() {
    this.modalRef = this.modalService.show(this.template, { class: 'modal-lg' });
  }
  /**
   * Esta funcion es la encargada de retornar la respuesta del usuario
   *
   * @private
   * @param {*} value
   * @memberof ModalTableComponent
   */
  private response(value: any): void {
    this.modalRef.hide();
    this.evtResponse.emit(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal-table/modal-table.component.ts